import { cfRegex } from "./../../../../utils/cfRegex";
import * as Yup from "yup";
import { getTodayDate, toEnDateString } from "../../../../utils/dateUtils";
import { isCustomerDistrictRequired } from "../../../../utils/districtUtils";

const todayDate = toEnDateString(getTodayDate());

// gate di variante (default = Linde)
const isDistrictEnabled = () => process.env.REACT_APP_ENABLE_DISTRICT !== "false";
const isStrictAddress = () => process.env.REACT_APP_STRICT_ADDRESS_VALIDATION !== "false";
const requiredAddressField = () => isStrictAddress()
	? Yup.mixed().required("Obbligatorio").nullable()
	: Yup.mixed().nullable();
const capAddressField = () => isStrictAddress()
	? Yup.number().required("Obbligatorio").typeError("Inserire un numero valido").nullable()
	: Yup.mixed().nullable();

export const phone = Yup.object().shape(
	{
		phone: Yup.number()
			.typeError("Inserire un numero valido")
			.when("mobile", {
				is: (mobile) => !mobile || mobile.length === 0,
				then: Yup.number().typeError("Inserire un numero valido").required("At least one of the fields is required"),
			}).nullable(),
		mobile: Yup.number()
			.typeError("Inserire un numero valido")
			.when("phone", {
				is: (mobile) => !mobile || mobile.length === 0,
				then: Yup.number().typeError("Inserire un numero valido").required("At least one of the fields is required"),
			}).nullable(),
	},
	["phone", "mobile"]
);

export const getValidationsPatient = (customer) => Yup.object().shape(
	{
		name: Yup.string().required("Obbligatorio").nullable(),
		surname: Yup.string().required("Obbligatorio").nullable(),
		cf: Yup.string()
			.matches(cfRegex, "Inserire CF valido")
			.required("Obbligatorio").nullable(),
		birthDate: Yup.date()
			.max(todayDate, `La data non può essere maggiore di oggi`)
			.required("Obbligatorio").nullable(),
		email: Yup.string().email("Inserire mail valida").nullable(),

		phone: Yup.number()
			.typeError("Inserire un numero valido")
			.when("mobile", {
				is: (mobile) => !mobile,
				then: Yup.number().typeError("Inserire un numero valido").required("Compilare almeno uno tra telefono o cellulare"),
			}).nullable(),
		mobile: Yup.number()
			.typeError("Inserire un numero valido")
			.when("phone", {
				is: (phone) => !phone,
				then: Yup.number().typeError("Inserire un numero valido").required("Compilare almeno uno tra telefono o cellulare"),
			}).nullable(),

		residence: Yup.object().shape({
			street: requiredAddressField(),
			number: requiredAddressField(),
			internal: Yup.number().typeError("Inserire un numero valido").nullable(),
			cap: capAddressField(),
			city: requiredAddressField(),
			province: requiredAddressField(),
			districtGuid: (isDistrictEnabled() && isCustomerDistrictRequired(customer))
				? Yup.string().required("Obbligatorio").nullable()
				: Yup.mixed().nullable(),
		}),

		domicile: Yup.mixed().when("isDomicileDifferent", {
			is: true,
			then: Yup.object().shape({
				street: requiredAddressField(),
				number: requiredAddressField(),
				internal: Yup.number().typeError("Inserire un numero valido").nullable(),
				cap: capAddressField(),
				city: requiredAddressField(),
				province: requiredAddressField(),
			}),
			otherwise: Yup.object().nullable().notRequired(),
		}),
	},
	["phone", "mobile"]
);
